import { defineComponent as _defineComponent } from 'vue'
import { MapboxGeoJSONFeature } from 'mapbox-gl'
import { computed } from 'vue'
import { formatDateTime } from '@/utils/date-formatting'
import moment from 'moment/moment'
import { useGetters } from 'vuex-composition-helpers'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourceHover',
  props: {
    hoveredFeature: null
  },
  setup(__props: any) {

const props = __props as {
  hoveredFeature?: MapboxGeoJSONFeature
}



const { getBySid } = useGetters('users', ['getBySid'])

const operatorName = computed<string | null>(() => {
  if (props.hoveredFeature?.properties?.OperatorSid) {
    return getBySid.value(props.hoveredFeature?.properties?.OperatorSid)?.name
  }
  return null
})

const lastLocationName = computed<string | null>(() => {
  if (props.hoveredFeature?.properties?.LastLocationUserSid) {
    return getBySid.value(props.hoveredFeature?.properties?.LastLocationUserSid)
      ?.name
  }
  return null
})

const onDutyColor = computed<string>(() => {
  if (props.hoveredFeature?.properties?.OnDuty) {
    return 'teal accent-2'
  }
  return 'grey lighten-1'
})

const onDutySubtext = computed<string | null>(() => {
  if (!props.hoveredFeature?.properties?.OperatorName) return null
  if (props.hoveredFeature?.properties?.OnDuty) {
    return `On duty since ${formatDateTime(
      moment.utc(props.hoveredFeature?.properties?.OperatorOccuredAt).local()
    )}`
  } else {
    return `Last on duty ${formatDateTime(
      moment.utc(props.hoveredFeature?.properties?.OperatorOccuredAt).local()
    )}`
  }
})

const latestUpdatedInfo = computed<string | null>(() => {
  if (lastLocationName.value) {
    return `${lastLocationName.value} - ${moment
      .utc(props.hoveredFeature?.properties?.LastLocationGPSUpdatedTime)
      .local()
      .fromNow()}`
  }
  return null
})

return { __sfc: true,props, getBySid, operatorName, lastLocationName, onDutyColor, onDutySubtext, latestUpdatedInfo }
}

})